import { useUITheme } from "@/app/hooks/ui_hooks/useUITheme";
import clsx from "clsx";
import { INoREcordFound } from "../interface";

const NoItemFoundComponent: React.FC<INoREcordFound> = ({
  message,
  description,
  imageURL,
  className,
  InputClassName,
}) => {
  const { theme } = useUITheme();
  return (
    <>
      <div className={`flex flex-col    h-auto justify-center items-center my-5 -mt-6 ${InputClassName}`}>
        {imageURL && (
          <div className="absolute">
            <img
              src={imageURL}
              alt="logo"
              className={clsx("relative h-auto w-auto", className, theme !== "VETIC" && "invert")}
              width={250}
              height={250}
            />
            <p className="font-semibold text-center text-gray-700 text-xs 2xl:text-sm">
              {message}
              <p className="font-normal text-center text-gray-500 text-xs"> {description ?? ""}</p>
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default NoItemFoundComponent;
